import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathViewBigCommerceSettingsShforms() {
  return `view/bigcommerce-settings-shforms`;
}

export function getViewBigCommerceSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewBigCommerceSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathBigCommerceSettings() {
  return `bigcommerce-settings`;
}

export function patchBigCommerceSettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathBigCommerceSettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getBigCommerceClientId(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`get-bigcommerce-client-id`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
